export default {
    methods: {
        mUtilitiesNumberExcel(numberText) {
            const [number, decimal] = numberText.split('.');
            return `${number},${decimal}`;
        }
    }
}